"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _text = babelHelpers.interopRequireDefault(require("./text"));

var instance = new _text.default('terms-sidebar-modal', 'Terms of Use', 'data/legal?notice=TermsOfUse');
var _default = instance;
exports.default = _default;